import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useParams } from "react-router-dom";
import { decodeToken, getToken } from "../../utils/TokenUtils";
import { API_URL, ENDPOINTS } from "../../constants/api";
import axios from 'axios';

const RegistrationLetter = () => {
  const { id, route } = useParams();
  const token = getToken();
  const banner = decodeToken(token, "banner");
  const user_id = decodeToken(token, "id");
  const username = decodeToken(token, "name");
  const [data, setData] = useState([]);

  useEffect(() => {
    const url = `${API_URL}/${ENDPOINTS.SYS}/reportCustom/${route}`;
    const fetchData = async () => {
      try {
        const response = await axios.post(url, { student_id: id, user_id }, {
          headers: { Authorization: token ? `Bearer ${token}` : '' },
        });
        setData(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [route, id, user_id, token]);

  useEffect(() => {
    if (data.length <= 0) return;
    const timer = setTimeout(() => {
      window.print();
    }, 1000); 
    return () => clearTimeout(timer);
  }, [data]);

  if (data.length <= 0) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "400px" }}>
        <div className="spinner-border text-secondary" role="status">
          <span className="visually-hidden">Loading Document...</span>
        </div>
      </div>
    );
  }

  return (
    <>
      {/* Strict Print Overrides */}
      <style>{`
        @media print {
          body { background: #fff; margin: 0; padding: 0; }
          .print-letter-container { 
            box-shadow: none !important; 
            border: 2px solid #0f172a !important;
            margin: 0 !important;
            padding: 5mm !important;
          }
        }
      `}</style>

      <div 
        className="print-letter-container"
        style={{
          width: "210mm",
          minHeight: "297mm", 
          margin: "20px auto",
          fontFamily: "'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
          backgroundColor: "#fff",
          padding: "8mm",
          boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
          border: "4px double #0f172a",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        <div>
          {/* Institutional Header Banner */}
          <div className="text-center mb-4">
            <img
              src={`${API_URL}/${banner}`}
              alt="Institution Header"
              style={{ width: "100%", maxHeight: "110px", objectFit: "fill" }}
            />
          </div>

          {/* Reference Block */}
          <div className="d-flex justify-content-between align-items-center mb-4" style={{ borderBottom: "1px solid #cbd5e1", paddingBottom: "10px" }}>
            <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>
              REF NO: <span style={{ color: "#0f172a" }}>REG-{id || "000"}</span>
            </span>
            <span style={{ fontSize: "13px", fontWeight: "600", color: "#475569" }}>
              TAARIIKHDA: <span style={{ color: "#0f172a" }}>{new Date().toLocaleDateString("en-GB")}</span>
            </span>
          </div>

          {/* Document Title */}
          <div className="text-center my-4">
            <h4 style={{ 
              fontWeight: "700", 
              textTransform: "uppercase", 
              letterSpacing: "1.5px",
              color: "#0f172a",
              margin: 0
            }}>
              FOOMKA ARDAYGA CUSUB
            </h4>
            <div style={{ width: "60px", height: "3px", backgroundColor: "#0f172a", margin: "8px auto 0" }}></div>
          </div>

          {/* Information Layout Grid */}
          {data.map((item, index) => {
            const studentImage = item.student_image || item.sawir || item._image;

            return (
              <div key={index} className="row mt-4 g-4 align-items-start">
                
                {/* Field-Value Clean Grid */}
                <div className="col-8">
                  <div className="row g-3">
                    {Object.entries(item)
                      .filter(([key]) => !key.startsWith("_") && key !== "student_image" && key !== "sawir")
                      .map(([key, value]) => (
                        <div key={key} className="col-12">
                          <div 
                            style={{ 
                              display: "flex", 
                              alignItems: "baseline",
                              paddingBottom: "8px",
                              borderBottom: "1px dashed #e2e8f0" 
                            }}
                          >
                            {/* Field Name */}
                            <div 
                              style={{ 
                                width: "40%", 
                                fontSize: "13px", 
                                fontWeight: "700", 
                                color: "#64748b",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px"
                              }}
                            >
                              {key.replace(/_/g, ' ')}
                            </div>
                            
                            {/* Value */}
                            <div 
                              style={{ 
                                width: "60%", 
                                fontSize: "15px", 
                                fontWeight: "600", 
                                color: "#0f172a",
                                paddingLeft: "15px"
                              }}
                            >
                              {value || "—"}
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                {/* Passport Frame Column */}
                <div className="col-4 d-flex flex-column align-items-center">
                  <div 
                    style={{ 
                      width: "40mm", 
                      height: "48mm", 
                      border: "1px solid #cbd5e1", 
                      borderRadius: "4px",
                      padding: "4px",
                      backgroundColor: "#f8fafc",
                    }}
                  >
                    <img 
                      src={studentImage ? `${API_URL}/${studentImage}` : "https://via.placeholder.com/150x180?text=PASSPORT+PHOTO"} 
                      alt="Student Portrait" 
                      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "2px" }}
                    />
                  </div>
                  <span style={{ fontSize: "11px", fontWeight: "700", color: "#64748b", marginTop: "8px", letterSpacing: "0.5px" }}>
                    SAWIRKA ARDAYGA
                  </span>
                </div>

              </div>
            );
          })}
        </div>

        {/* Footer Area */}
        <div>
          {/* Signatures Row */}
<div className="row" style={{ marginTop: "20px", marginBottom: "30px" }}>
  
  {/* Guardian Authorization */}
  <div className="col-6">
    <div style={{ width: "85%", marginRight: "auto" }}>
      {/* 1. Name */}
      <p style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", margin: "0 0 2px 0" }}>
        {data[0]._guardian}
      </p>
      {/* 2. Label */}
      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "600", display: "block" }}>
        Saxiixa Waalidka / Guardian Signature
      </span>
      {/* 3. Signature Line Space & Line */}
      <div style={{ height: "45px" }}></div> 
      <div style={{ borderTop: "1px dashed #0f172a", width: "100%" }}></div>
    </div>
  </div>

  {/* Registrar Authority */}
  <div className="col-6">
    <div style={{ width: "85%", marginLeft: "auto" }}>
      {/* 1. Name */}
      <p style={{ fontSize: "14px", fontWeight: "700", color: "#0f172a", margin: "0 0 2px 0", textTransform: "uppercase" }}>
        {data[0]._registrar}
      </p>
      {/* 2. Label */}
      <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "600", display: "block" }}>
        Saxiixa Diwaangeliyaha / Registrar Signature
      </span>
      {/* 3. Signature Line Space & Line */}
      <div style={{ height: "45px" }}></div> 
      <div style={{ borderTop: "1px dashed #0f172a", width: "100%" }}></div>
    </div>
  </div>

</div>

   
          <div
            style={{
              borderTop: "1px solid #e2e8f0",
              paddingTop: "12px",
              textAlign: "center",
              fontSize: "11px",
              color: "#94a3b8",
              fontWeight: "500",
              letterSpacing: "0.5px"
            }}
          >
            Developed By Kaafiye Technology Center (KTC)
          </div>
        </div>

      </div>
    </>
  );
};

export default RegistrationLetter;